import React from 'react';

import { Accordion, createStyles } from '@mantine/core';

const useStyles = createStyles(() => ({
    item: {
        border: 0,
    },
    control: {
        padding: '0 10px',
    },
    icon: {
        marginRight: '16px',
        transform: 'rotate(-90deg)',
    },
    label: {
        textTransform: 'uppercase',
        fontSize: '12px',
        letterSpacing: '0.5px',
        fontWeight: 'bold',
    },
    content: {
        paddingLeft: '10px',
        paddingRight: '0',
    },
    contentInner: {
        padding: '0',
    },
}));

function StyledAccordion({ _, ...otherProps }) {
    const { classes } = useStyles();

    return (
        <Accordion
            classNames={classes}
            {...otherProps}
        />
    );
}

export default StyledAccordion;
